import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-black">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Link 
          to="/"
          className="inline-flex items-center gap-2 text-gray-400 hover:text-white mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour à l'accueil
        </Link>

        <h1 className="text-3xl font-bold text-white mb-8">Conditions Générales d'Utilisation</h1>

        <div className="prose prose-invert max-w-none">
          <p className="text-gray-300 mb-6">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Acceptation des Conditions</h2>
          <p className="text-gray-300 mb-6">
            En accédant et en utilisant les services de Botmaker Agency, vous acceptez d'être lié par les présentes conditions générales d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser nos services.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Description des Services</h2>
          <p className="text-gray-300 mb-6">
            Botmaker Agency fournit une plateforme de création et de gestion de chatbots intelligents. Nos services incluent :
          </p>
          <ul className="list-disc pl-6 text-gray-300 mb-6">
            <li>Création de chatbots personnalisés</li>
            <li>Intégration d'intelligence artificielle</li>
            <li>Mini-applications intégrées</li>
            <li>Analyse et suivi des performances</li>
          </ul>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Comptes Utilisateurs</h2>
          <p className="text-gray-300 mb-6">
            Pour utiliser nos services, vous devez créer un compte. Vous êtes responsable de maintenir la confidentialité de vos identifiants et de toutes les activités qui se produisent sous votre compte.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Abonnements et Paiements</h2>
          <p className="text-gray-300 mb-4">
            Nos services sont proposés sous forme d'abonnements avec différents niveaux de fonctionnalités :
          </p>
          <ul className="list-disc pl-6 text-gray-300 mb-6">
            <li>Les paiements sont effectués mensuellement ou annuellement</li>
            <li>Les abonnements se renouvellent automatiquement</li>
            <li>Vous pouvez annuler votre abonnement à tout moment</li>
          </ul>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Propriété Intellectuelle</h2>
          <p className="text-gray-300 mb-6">
            Tous les droits de propriété intellectuelle relatifs à nos services sont la propriété exclusive de Botmaker Agency. Vous ne pouvez pas copier, modifier, distribuer ou utiliser notre contenu sans autorisation.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Utilisation Acceptable</h2>
          <p className="text-gray-300 mb-4">
            Vous acceptez de ne pas :
          </p>
          <ul className="list-disc pl-6 text-gray-300 mb-6">
            <li>Utiliser nos services à des fins illégales</li>
            <li>Perturber ou interférer avec nos services</li>
            <li>Collecter des informations sans autorisation</li>
            <li>Violer les droits d'autrui</li>
          </ul>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Limitation de Responsabilité</h2>
          <p className="text-gray-300 mb-6">
            Nos services sont fournis "tels quels" sans garantie d'aucune sorte. Nous ne sommes pas responsables des dommages directs, indirects, accessoires ou consécutifs résultant de l'utilisation de nos services.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">8. Modifications</h2>
          <p className="text-gray-300 mb-6">
            Nous nous réservons le droit de modifier ces conditions à tout moment. Les modifications entrent en vigueur dès leur publication. Votre utilisation continue des services après toute modification constitue votre acceptation des nouvelles conditions.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">9. Contact</h2>
          <p className="text-gray-300 mb-6">
            Pour toute question concernant ces conditions, vous pouvez nous contacter à l'adresse suivante : legal@botmaker-agency.com
          </p>
        </div>
      </div>
    </div>
  );
}